import React from 'react';
import { useTranslation } from 'react-i18next';
import { makeStyles } from 'tss-react/mui';
import Icon from '../../../icons/components/Icon';
import { withPixelLineHeight } from '../../../styles/functions.web';
import { BUTTON_TYPES } from '../../constants.web';
const useStyles = makeStyles()(theme => {
    return {
        disabled: {
            backgroundColor: theme.palette.disabled01,
            color: theme.palette.default01,
            cursor: 'default',
            '&[class*="secondary"]': {
                backgroundColor: theme.palette.white,
                color: theme.palette.default01,
                borderColor: theme.palette.default00,
                '&:hover': {
                    backgroundColor: theme.palette.white,
                    color: theme.palette.default01,
                },
            },
            '&:hover': {
                backgroundColor: theme.palette.disabled01,
                color: theme.palette.default01
            },
            '&:active': {
                backgroundColor: theme.palette.disabled01,
                color: theme.palette.default01
            },
            '& div > svg': {
                fill: theme.palette.icon03
            }
        },
        button: {
            backgroundColor: theme.palette.primary10,
            color: theme.palette.text01,
            borderRadius: theme.shape.borderRadius,
            padding: '7px 16px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            border: 0,
            ...withPixelLineHeight(theme.typography.bodyShortBoldLarge),
            transition: 'background .2s',
            cursor: 'pointer',
            '&:hover': {
                backgroundColor: theme.palette.redP01
            },
            '&:active': {
                backgroundColor: theme.palette.primaryActive
            },
            '&.focus-visible': {
                outline: 0,
                boxShadow: `0px 0px 0px 2px ${theme.palette.focus01}`
            },
            '& div > svg': {
                fill: theme.palette.icon01
            }
        },
        primary: {},
        secondary: {
            backgroundColor: theme.palette.redP01 + '04',
            color: theme.palette.outline,
            border: `1px solid ${theme.palette.outline}`,
            padding: '6px 15px',
            '&:hover': {
                backgroundColor: theme.palette.redP01 + '12'
            },
            '&:active': {
                backgroundColor: theme.palette.redP01 + '12'
            },
            '& div > svg': {
                fill: theme.palette.redP01
            }
        },
        tertiary: {
            backgroundColor: theme.palette.action03,
            '&:hover': {
                backgroundColor: theme.palette.action03Hover
            },
            '&:active': {
                backgroundColor: theme.palette.action03Active
            }
        },
        destructive: {
            backgroundColor: theme.palette.actionDanger,
            '&:hover': {
                backgroundColor: theme.palette.actionDangerHover
            },
            '&:active': {
                backgroundColor: theme.palette.actionDangerActive
            }
        },
        iconButton: {
            padding: theme.spacing(2)
        },
        textWithIcon: {
            marginLeft: theme.spacing(2)
        },
        extraSmall: {
            height: '32px',
            fontSize: '14px',
        },
        small: {
            fontSize: '14px !important',
            height: '36px',
            padding: '6px 8px',
            '&.iconButton': {
                padding: theme.spacing(1)
            }
        },
        mediumSmall: {
            // fontSize: '14px !important',
            height: '36px',
        },
        smallMedium: {
            height: '32px',
            fontSize: '14px',
        },
        bMedium: {
            height: '36px',
            fontSize: '16px',
        },
        medium: {
            height: '40px',
            fontSize: '16px',
        },
        tiny: {
            fontSize: '14px',
            padding: '4px 8px',
            '&.iconButton': {
                padding: theme.spacing(1)
            }
        },
        large: {
            height: '48px',
            fontSize: '20px',
            padding: '13px 16px',
            ...withPixelLineHeight(theme.typography.bodyShortBoldLarge),
            '&.iconButton': {
                padding: '12px'
            }
        },
        extraLarge: {
            height: '52px',
            fontSize: '20px',
        },
        fullWidth: {
            width: '100%'
        }
    };
});
const Button = React.forwardRef(({ accessibilityLabel, autoFocus = false, className, disabled, fullWidth, icon, id, isSubmit, label, labelKey, onClick = () => null, onKeyPress = () => null, size = 'medium', testId, type = BUTTON_TYPES.PRIMARY }, ref) => {
    const { classes: styles, cx } = useStyles();
    const { t } = useTranslation();
    return (React.createElement("button", { "aria-label": accessibilityLabel, autoFocus: autoFocus, className: cx(styles.button, styles[type], disabled && styles.disabled, icon && !(labelKey || label) && `${styles.iconButton} iconButton`, fullWidth && styles.fullWidth, className, styles[size]), "data-testid": testId, disabled: disabled, ...(id ? { id } : {}), onClick: onClick, onKeyPress: onKeyPress, ref: ref, title: accessibilityLabel, type: isSubmit ? 'submit' : 'button' },
        icon && React.createElement(Icon, { size: 24, src: icon }),
        (labelKey || label) && React.createElement("span", { className: icon ? styles.textWithIcon : '' }, labelKey ? t(labelKey) : label)));
});
export default Button;
